/* ============
 * Vuex Actions
 * ============
 *
 * All the actions that can be used
 * inside the store
 */
import * as types from './mutation-types';

// Account
export const getAccount = ({ commit }, account) => {
  commit(types.GET_ACCOUNT, account);
};

// Auth
export const login = ({ commit }, token) => {
  commit(types.LOGIN, token);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const checkAuthentication = ({ commit }) => {
  commit(types.CHECK_AUTHENTICATION);
};

// Benefits
export const setLists = ({ commit }, lists) => {
  commit(types.SET_LISTS, lists);
};
// Local
export const updateLocals = ({ commit }, locals) => {
  commit(types.UPDATE_LOCALS, locals);
};

// NETFLIX RECOMMENDATIONS
export const updateRecommendations = ({ commit }, cats) => {
  commit(types.UPDATE_RECOMMENDATIONS, cats);
};



// WEBPACK FOOTER //
// ./src/app/store/actions.js